import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var e = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-320 -900)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M9.99094 7.95764L10.9073 9.22038L12.3913 8.73917L11.4736 10.0008L12.3898 11.2636L10.9063 10.7806L9.98848 12.0423L9.98941 10.4821L8.50586 9.99909L9.98996 9.51788L9.99094 7.95764Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M7.4893 13.1564C5.74609 13.1564 4.33293 11.7432 4.33293 10C4.33293 8.25676 5.74605 6.84363 7.4893 6.84363C8.03281 6.84363 8.54422 6.98105 8.99074 7.22297C8.29031 6.53801 7.33238 6.11523 6.27535 6.11523C4.12988 6.11523 2.39062 7.85449 2.39062 9.99996C2.39062 12.1454 4.12988 13.8847 6.27535 13.8847C7.33238 13.8847 8.29031 13.4619 8.99074 12.777C8.54422 13.0189 8.03281 13.1564 7.4893 13.1564Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  e as default
};
